import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import styles from './SearchBarSection.scss';

export const SearchBarSectionComponent = ({ isNavigationRefreshVariant, title, children }) => {
    const sectionClassName = classNames(styles.section, {
        [styles.navigationRefreshSection]: isNavigationRefreshVariant,
    });

    return (
        <div data-tn="search-bar-section" className={sectionClassName}>
            <div data-tn="search-bar-header" className={styles.header}>
                {title}
            </div>
            {children}
        </div>
    );
};

SearchBarSectionComponent.propTypes = {
    title: PropTypes.node,
    children: PropTypes.node,
    isNavigationRefreshVariant: PropTypes.bool,
};

const mapStateToProps = ({ header }) => {
    const { isNavigationRefreshVariant } = header;
    return {
        isNavigationRefreshVariant,
    };
};

export const SearchBarSection = connect(mapStateToProps)(SearchBarSectionComponent);
